import DefaultPreset from './Default'
import BamboraEcommerce from './BamboraEcommerce/index'
import BamboraEcommerceV2 from './BamboraEcommerceV2'
import StyledSinglePageFlow from './StyledSinglePageFlow/index'
import LocalPresets from './LocalPresets'
import NewThemesApril2020 from './2020-04-20/2020-04-20'
import iGamingCanda from './iGaming-Canada/index'
import SinglePageFlow from './SinglePageFlow/index'
import PaymentIQCheckout from './PaymentIQCheckout/index'
// import DefaultBlack from './DefaultRound/index'

// Old presets - still not deleted from this folder, but removed from being used.
// import DesertTheme from './Desert/index'
// import DefaultBlack from './DefaultRound/index'
// import DarkMode from './DarkMode/index'
// import eCommerceUK from './eCommerceUK/index'
// import iGamingSweden from './iGamingSweden/index'
// import BlueTheme from './BlueMode/index'
// import BlackWhiteTheme from './BlackAndWhite/index'
// import eCommerceDenmark from './eCommerceDenmark/index'
// import eCommerceCanda from './eCommerceCanada/index'
// import YellowTheme from './YellowGrids'
// import DesertTheme from './Desert/index'
// TEST NEW THEME PRESETS WITH THE TEST PROPERTY
// Test presets with './TestPreset/index'
// import Test from './TestPreset/index'

export default {
  DefaultPreset,
  StyledSinglePageFlow,
  ...BamboraEcommerce,
  BamboraEcommerceV2,
  ...NewThemesApril2020,
  ...LocalPresets,
  iGamingCanda,
  ...SinglePageFlow,
  ...PaymentIQCheckout
  // Test
}
